import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { Subject, Subscription } from 'rxjs';
import PropTypes from 'prop-types';
var withLoaderState = function withLoaderState(WrappedComponent) {
  var loadedDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var LoaderState = /*#__PURE__*/function (_PureComponent) {
    _inherits(LoaderState, _PureComponent);
    var _super = _createSuper(LoaderState);
    function LoaderState(props) {
      var _this;
      _classCallCheck(this, LoaderState);
      _this = _super.call(this, props);
      _this.subject = new Subject();
      _this.subscriptions = new Subscription();
      _this.state = {
        loaded: loadedDefault
      };
      _this.calls = 0;
      _this.stop = _this.stop.bind(_assertThisInitialized(_this));
      _this.start = _this.start.bind(_assertThisInitialized(_this));
      _this.isLoaded = _this.isLoaded.bind(_assertThisInitialized(_this));
      _this.subscriptions.add(_this.subject.subscribe(_this.eventsSubscriber.bind(_assertThisInitialized(_this))));
      return _this;
    }
    _createClass(LoaderState, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.subscriptions.unsubscribe();
      }
    }, {
      key: "eventsSubscriber",
      value: function eventsSubscriber(event) {
        switch (event.type) {
          case 'STOP':
            this.setState({
              loaded: true
            });
            break;
          case 'START':
            this.setState({
              loaded: false
            });
            break;
          default:
            throw new Error("Unknown event type: ".concat(event.type));
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        this.calls -= 1;
        if (this.calls === 0) {
          this.subject.next({
            type: 'STOP'
          });
        }
      }
    }, {
      key: "start",
      value: function start() {
        this.calls += 1;
        this.subject.next({
          type: 'START'
        });
      }
    }, {
      key: "isLoaded",
      value: function isLoaded() {
        var loaded = this.state.loaded;
        return loaded === true;
      }
    }, {
      key: "render",
      value: function render() {
        var loaderHandler = {
          stop: this.stop,
          start: this.start,
          isLoaded: this.isLoaded
        };
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          loaderHandler: loaderHandler
        }));
      }
    }]);
    return LoaderState;
  }(PureComponent);
  return LoaderState;
};
export default withLoaderState;
export var withLoaderStatePropTypes = {
  loaderHandler: PropTypes.shape({
    isLoaded: PropTypes.func.isRequired,
    start: PropTypes.func.isRequired,
    stop: PropTypes.func.isRequired
  }).isRequired
};